// Mock data for Kato Mito Swedish Candy B2B Website

export const brandColors = {
  navy: '#2D1B69',
  yellow: '#F4D03F', 
  cyan: '#17A2B8',
  white: '#FFFFFF',
  lightGray: '#F8F9FA',
  darkGray: '#343A40'
};

export const heroData = {
  title: "Premium Swedish Candy Wholesale Worldwide",
  subtitle: "KATO MITO",
  description: "Global bulk wholesale Swedish candy supplier with partners across North America, Europe, Asia, Australia, Middle East, South America & Africa. Making happy memories worldwide with foamy candy, skull candy, and authentic Swedish confections. From 4OZ variety packs to 5LB bulk options for international B2B retailers.",
  cta: "Explore Our Products",
  backgroundImage: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=1200&h=800&fit=crop"
};

export const brandStory = {
  title: "Our Story",
  subtitle: "Making Happy Memories Worldwide",
  content: `KATO MITO, a global brand born from the love of Scandinavian simplicity and indulgence. Our Swedish Style Candy collection reaches partners across continents, crafting sweet moments that transcend borders and create happy memories worldwide.

From bustling markets in Asia to elegant boutiques in Europe, from vibrant stores across the Americas to innovative retailers in Australia and the Middle East, Kato Mito is a Swedish-style candy brand where confectionery becomes a universal sensory experience. Inspired by the bold traditions of Swedish godis, the curiosity of global flavor culture, and the elegance of European ingredients, each piece is crafted to evoke emotion, spark memory, and whisper indulgence across cultures.

We blend unexpected flavor combinations—sweet, sour, salty—with clean, minimal design that speaks a universal language. Our confections are made for the flavor-forward, the design-conscious, and the quietly daring in every corner of the world. These candies are more than just treats; they are a global sensory experience designed to stand out on shelves from Tokyo to Toronto, Dubai to São Paulo, sparking delight in every customer worldwide.

Whether gifting or indulging, Kato Mito offers more than candy. It's a pause in your day, a little rebellion, a sophisticated sweet escape—now shared by partners on six continents, making happy memories together around the globe.`,
  image: "https://images.unsplash.com/photo-1486427944299-d1955d23e34d?w=600&h=400&fit=crop"
};

export const products = [
  {
    id: 1,
    name: "4OZ Variety Packs",
    description: "Premium mixed Swedish-style candy in convenient 4OZ retail packages. Perfect for introducing customers to our unique flavor profiles.",
    features: [
      "Mixed variety of Swedish-style candies",
      "Premium packaging design", 
      "Perfect portion size",
      "12 packs per case",
      "6-month shelf life"
    ],
    image: "https://images.unsplash.com/photo-1514517521153-1be72277b32f?w=400&h=300&fit=crop",
    category: "retail",
    candyType: "swedish",
    minimumOrder: "48 units",
    pricing: "Contact for wholesale pricing"
  },
  {
    id: 2,
    name: "5LB Bulk Packs",
    description: "Large format bulk candy perfect for pick-and-mix displays, candy bars, or high-volume retail operations.",
    features: [
      "5LB food-safe bulk packaging",
      "Ideal for pick-and-mix stations",
      "Multiple flavor options",
      "Resealable packaging",
      "Extended shelf life"
    ],
    image: "https://images.unsplash.com/photo-1571506165871-ee72a35bbc9d?w=400&h=300&fit=crop",
    category: "bulk",
    candyType: "swedish",
    minimumOrder: "10 units",
    pricing: "Contact for wholesale pricing"
  },
  {
    id: 3,
    name: "Custom & Private Label",
    description: "Create your own unique Swedish-style candy with custom shapes, flavors, and colors. Perfect for private label opportunities.",
    features: [
      "Custom shapes and molds",
      "Unique flavor combinations",
      "Custom color options",
      "Private label packaging",
      "Low minimum orders",
      "Brand consultation included"
    ],
    image: "https://images.unsplash.com/photo-1576618148400-f54bed99fcfd?w=400&h=300&fit=crop",
    category: "custom",
    candyType: "swedish",
    minimumOrder: "500 units",
    pricing: "Custom quote based on specifications"
  },
  {
    id: 4,
    name: "Crystal Candy Gems",
    description: "Brilliant crystal-clear candies with intense flavors and stunning visual appeal. Perfect for premium retail displays.",
    features: [
      "Crystal-clear transparency",
      "Intense flavor concentration",
      "Brilliant color presentation",
      "Premium gift packaging",
      "Extended shelf stability"
    ],
    image: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=400&h=300&fit=crop",
    category: "retail",
    candyType: "crystal",
    minimumOrder: "24 units",
    pricing: "Premium pricing available"
  },
  {
    id: 5,
    name: "Crystal Bulk Collections",
    description: "Large format crystal candy perfect for high-end pick-and-mix displays and premium candy bars.",
    features: [
      "3LB premium packaging",
      "Multiple crystal varieties",
      "Superior clarity standards",
      "Moisture-resistant containers",
      "Premium positioning support"
    ],
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=300&fit=crop",
    category: "bulk",
    candyType: "crystal",
    minimumOrder: "8 units",
    pricing: "Premium wholesale rates"
  },
  {
    id: 6,
    name: "Custom Crystal Creations",
    description: "Bespoke crystal candy designs with custom cuts, colors, and flavors. The ultimate in premium confectionery luxury.",
    features: [
      "Custom crystal cutting",
      "Bespoke flavor development",
      "Exclusive color matching",
      "Luxury presentation boxes",
      "Design consultation included",
      "Limited edition options"
    ],
    image: "https://images.unsplash.com/photo-1587399951106-3d9de4f6e824?w=400&h=300&fit=crop",
    category: "custom",
    candyType: "crystal",
    minimumOrder: "200 units",
    pricing: "Luxury tier pricing"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "@candylover_tokyo",
    platform: "TikTok",
    content: "OMG these Swedish candies from Kato Mito are INSANE! Shipping to Japan was smooth, flavors are unique and texture is perfect. Our customers in Tokyo can't get enough! 🍭✨🇯🇵",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b977?w=100&h=100&fit=crop&crop=face",
    views: "247K",
    likes: "18.2K"
  },
  {
    id: 2,
    name: "@retailboss_london",
    platform: "TikTok", 
    content: "Been carrying Kato Mito for 6 months in our London stores - best international candy supplier! Quality is consistent worldwide, customers love the authentic Swedish style 🇸🇪🌍",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    views: "189K",
    likes: "15.1K"
  },
  {
    id: 3,
    name: "@dulceria_saopaulo",
    platform: "TikTok",
    content: "Kato Mito transformed our store in São Paulo! Custom candy options perfect for Brazilian market. Sales up 60% and making happy memories with every customer! Obrigado! 🙌🇧🇷",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
    views: "203K",
    likes: "22.7K"
  }
];

export const features = [
  {
    icon: "Candy",
    title: "Premium Quality",
    description: "Swedish-style confections made with the finest European ingredients and traditional techniques."
  },
  {
    icon: "Palette",
    title: "Custom Options",
    description: "Create unique candy experiences with custom shapes, flavors, and colors tailored to your brand."
  },
  {
    icon: "Package",
    title: "Flexible Packaging",
    description: "We offer sweet packaging solutions for every business need."
  },
  {
    icon: "Award",
    title: "B2B Excellence",
    description: "Dedicated wholesale support with competitive pricing, reliable delivery, and exceptional service."
  }
];

export const contactInfo = {
  email: "info@katomito.com",
  phone: "+1-917-9638841",
  address: "7320 E Fletcher Ave, Tampa, FL 33637, USA",
  businessHours: "Monday - Friday: 9AM - 6PM EST"
};

export const stats = [
  { label: "Global Partners", value: "500+" },
  { label: "Countries Served", value: "45+" },
  { label: "Candy Varieties", value: "25+" },
  { label: "Customer Satisfaction", value: "98%" }
];

export const faqData = [
  {
    question: "What is the minimum order quantity?",
    answer: "Minimum orders vary by product: 48 units for 4OZ packs, 10 units for 5LB bulk, and 500 units for custom orders. Flexible options available for international partners."
  },
  {
    question: "Do you offer private label services?",
    answer: "Yes! We offer complete private label services including custom packaging design, unique flavor development, and branded packaging solutions tailored for markets worldwide."
  },
  {
    question: "What is the shelf life of your products?",
    answer: "Our candies have a 6-12 month shelf life depending on the product type. All products include clear expiration dating and storage instructions, perfect for long-distance international shipping."
  },
  {
    question: "Do you ship internationally?",
    answer: "Absolutely! We ship worldwide to partners across North America, South America, Europe, Asia, Australia, Middle East, and Africa. We have established shipping routes to over 45 countries and work with reliable international logistics partners to ensure your candy arrives fresh and on time."
  },
  {
    question: "Can I get samples before placing a large order?",
    answer: "Yes! We offer international sample shipping for all wholesale customers worldwide. This ensures product quality meets your market expectations before committing to larger orders, no matter where you're located."
  }
];